import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OrganizationSetupInfo: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Box
      sx={{
        maxWidth: 600,
        mx: 'auto',
        mt: 6,
        px: 3,
        py: 4,
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        backgroundColor: 'background.paper',
        boxShadow: (theme) => theme.shadows[1],
      }}
    >
      <Stack spacing={3}>
        <div>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('organizationSetup.infoTitle')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('organizationSetup.infoDescription')}
          </Typography>
        </div>
        <Box>
          <Button variant="contained" onClick={handleBackToDashboard}>
            {t('organizationSetup.infoAction')}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default OrganizationSetupInfo;
